import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CtaTextWithArrow from '../cta-text-with-arrow';
import ToggleButtonGroup from '../../toggle-button-group';
import PlanDesktop from '../plan-desktop';
import { DESKTOP_PLAN_PROPTYPES } from '../plan-desktop/constants';

const defaultToggle = {
  items: [],
  selectedId: null,
  disabled: false,
  fullwidth: false,
};

const defaultCta = {
  promoText: null,
  isCompact: false,
};

const PaywallHeader = ({
  isLoading = false,
  isCompact = false,
  isSticky = false,
  plans,
  toggle = defaultToggle,
  cta = defaultCta,
  isHiddenToggle = false,
  withExtraPrice = false,
  isCtaVisible = true,
}) => {
  const headerClass = classnames('ws-ui-paywall-header', {
    'ws-ui-paywall-header--is-compact': isCompact,
    'ws-ui-paywall-header--is-sticky': isSticky,
  });
  return (
    <div className={headerClass}>
      <div className="ws-ui-paywall-header__toggle-container">
        {!isHiddenToggle && (
          <div>
            <ToggleButtonGroup {...toggle} fullWidth={isCompact} />
            <div className="ws-ui-paywall-header__cta-wrapper">
              {isCtaVisible && <CtaTextWithArrow {...cta} isCompact={isCompact} />}
            </div>
          </div>
        )}
      </div>
      {!isCompact && (
        <React.Fragment>
          {plans.map((item) => (
            <PlanDesktop
              {...item}
              key={item.type}
              isLoading={isLoading}
              withExtraPrice={withExtraPrice}
            />
          ))}
        </React.Fragment>
      )}
    </div>
  );
};

PaywallHeader.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.shape(DESKTOP_PLAN_PROPTYPES)).isRequired,
  isLoading: PropTypes.bool,
  isCompact: PropTypes.bool,
  isHiddenToggle: PropTypes.bool,
  withExtraPrice: PropTypes.bool,
  isSticky: PropTypes.bool,
  toggle: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string,
        onClick: PropTypes.func,
        onKeyDown: PropTypes.func,
      })
    ),
    selectedId: PropTypes.string,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
  }),
  cta: PropTypes.shape({
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    promoText: PropTypes.string,
    isCompact: PropTypes.bool,
  }),
  isCtaVisible: PropTypes.bool,
};

export default PaywallHeader;
